// src/pages/employee/ApplyLeave.js
import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { AuthContext } from '../../components/AuthContext';

const ApplyLeave = () => {
  const { user } = useContext(AuthContext);
  const [leaves, setLeaves] = useState([]);
  const [form, setForm] = useState({
    startDate: '',
    endDate: '',
    leaveType: '',
    reason: '',
    employee: user?.user?._id
  });

  useEffect(() => {
    const fetchLeaves = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/leaves/${user?.user?._id}`);
        setLeaves(response.data);
      } catch (error) {
        Swal.fire('Error', 'Failed to fetch leaves', 'error');
      }
    };
    fetchLeaves();
  }, [user]);

  const fetchLeaves = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/leaves/${user?.user?._id}`);
      setLeaves(response.data);
    } catch (error) {
      Swal.fire('Error', 'Failed to fetch leaves', 'error');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/leaves`, form);
      Swal.fire('Success', 'Leave application submitted successfully', 'success');
      fetchLeaves();
      resetForm();
    } catch (error) {
      Swal.fire('Error', 'Failed to submit leave application', 'error');
    }
  };

  const validateForm = () => {
    if (!form.startDate || !form.endDate || !form.leaveType || !form.reason) {
      Swal.fire('Warning', 'All fields are required', 'warning');
      return false;
    }
    return true;
  };

  const resetForm = () => {
    setForm({
      startDate: '',
      endDate: '',
      leaveType: '',
      reason: '',
      employee: user?.user?._id
    });
  };

  return (
    <div className="p-6 bg-white shadow rounded-lg">
      <h2 className="text-3xl font-bold text-gray-800 mb-4">Apply Leave</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="flex items-center space-x-4">
          <div className="w-1/2">
            <label className="block text-gray-700 mb-2">Start Date</label>
            <input
              type="date"
              name="startDate"
              value={form.startDate}
              onChange={handleInputChange}
              className="w-full p-2 border rounded"
            />
          </div>

          <div className="w-1/2">
            <label className="block text-gray-700 mb-2">End Date</label>
            <input
              type="date"
              name="endDate"
              value={form.endDate}
              onChange={handleInputChange}
              className="w-full p-2 border rounded"
            />
          </div>
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Leave Type</label>
          <select
            name="leaveType"
            value={form.leaveType}
            onChange={handleInputChange}
            className="w-full p-2 border rounded"
          >
            <option value="">Select Leave Type</option>
            <option value="Sick Leave">Sick Leave</option>
            <option value="Personal Leave">Personal Leave</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Reason</label>
          <textarea
            name="reason"
            value={form.reason}
            onChange={handleInputChange}
            className="w-full p-2 border rounded"
            rows="5"
          />
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Submit Leave Application
          </button>
        </div>
      </form>

      <div className="mt-8 bg-white shadow rounded p-4">
        <h3 className="text-2xl font-bold mb-4">Leave History</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {leaves.length === 0 && (
            <p className="text-gray-500">No leave applications found.</p>
          )}
          {leaves.map((leave) => (
            <div key={leave._id} className="border p-4 rounded hover:shadow-md">
              <p className="font-bold">Type: {leave.leaveType}</p>
              <p className="text-sm">From: {new Date(leave.startDate).toLocaleDateString()}</p>
              <p className="text-sm">To: {new Date(leave.endDate).toLocaleDateString()}</p>
              <p className="text-sm">Status: {leave.status}</p>
              <p className="text-sm">Reason: {leave.reason}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ApplyLeave;
